import React from "react"

import {LexicalEditor} from "lexical"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"

type Props = {
    menuParams  : {
        options     : any[]
        editor      : LexicalEditor
        blockType   : any
    }
    showPopover : boolean
    isMinimized : boolean
    hidePopover : callback
}

export default function ToolbarInsertButton(props: Props) {

    const classes = Classes("flex-row-center-center w-100-percent", {
        'p-l-8 p-r-8'   : !props.isMinimized,
        'show-popover'  : props.showPopover
    })

    return (
        <ControlButtonStandard className={classes}>
            <div className="flex-row-left-center txt-truncate">
                <div className="ui5-ico-16 editor-i5-insert"/>
                {!props.isMinimized &&
                    <div className="ui5-txt-not-important-small lh-16 no-wrap m-l-5 txt-truncate">Insert</div>}
            </div>
        </ControlButtonStandard>
    )
}